/** Split FTS markers into text only. Stored HTML is always ordinary text. */
export function splitSearchSnippet(snippet: string): Array<{ text: string; matched: boolean }> {
  const parts: Array<{ text: string; matched: boolean }> = [];
  let matched = false;
  for (const text of snippet.split(/([\u0001\u0002])/)) {
    if (text === '\u0001') matched = true;
    else if (text === '\u0002') matched = false;
    else if (text) parts.push({ text, matched });
  }
  return parts;
}

/** Cleanup cancels the debounce and suppresses even a fetch that ignores abort. */
export function scheduleSearch<T>(
  request: (signal: AbortSignal) => Promise<T>,
  onSuccess: (result: T) => void,
  onError: (error: unknown) => void,
  delay = 300,
): () => void {
  const controller = new AbortController();
  const timer = setTimeout(async () => {
    try {
      const result = await request(controller.signal);
      if (!controller.signal.aborted) onSuccess(result);
    } catch (error) {
      if (!controller.signal.aborted) onError(error);
    }
  }, delay);
  return () => {
    clearTimeout(timer);
    controller.abort();
  };
}
